export const cardActions = {
  root: {
    padding: '0 1rem 1.25rem 1rem',
    '@media (min-width: 60rem)': {
      paddingLeft: '1.25rem',
      paddingRight: '1.25rem',
    },
  },
};
